const size = {
  small: '425px',
  medium: '768px',
  large: '1024px',
};

export const media = {
  S: `(min-width: ${size.small})`,
  M: `(min-width: ${size.medium})`,
  L: `(min-width: ${size.large})`,
};
